import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDadosIniciaisFechamentoPedido(axios, parametros) {
    parametros.operacao = 'buscarDadosIniciaisFechamentoPedido';

    let retorno = {};
    await axios.santriGET('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })
  
    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarDadosIniciaisFechamentoPedido.js